/** Legacy EP order list label — e.g. EP1-20251210-151834001 (never `php:123`). */

export function resolveEpOrderDisplayCode(order: {
  id: string;
  order_code?: string | null;
}): string {
  const code = order.order_code?.trim();
  if (code) return code;
  const bare = order.id.replace(/^php:/, '');
  return bare;
}

/** Integer EP amount for compact list rows (1310EP). */
export function formatEpListAmount(amount: string): string {
  const n = Number(amount);
  if (!Number.isFinite(n)) return amount;
  if (Number.isInteger(n)) return String(n);
  return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
